import { makeOpt, emptyOpt } from "../../../custom_utils/option";
export const trackNewsletter = ()=>DataLayer.push({
        category: "Newsletter",
        action: "Footer click",
        label: window.location.pathname
    });
export const trackSocial = (platform)=>DataLayer.push({
        category: "Socials",
        action: platform,
        label: window.location.pathname
    });
export const trackContact = (type)=>DataLayer.push({
        category: "Contact",
        action: type,
        label: window.location.pathname
    });
export const trackLogin = ()=>DataLayer.push({
        category: "Login",
        action: "Click",
        label: window.location.pathname
    });
export const trackJumboButton = (label)=>DataLayer.push({
        category: "Header button",
        action: label,
        label: window.location.pathname
    });
export const trackActivityClick = (activityTitle, clusterTitle)=>DataLayer.push({
        category: "Activities",
        action: clusterTitle,
        label: activityTitle
    });
export const trackActivitySubscribe = (date, start, end)=>DataLayer.push({
        category: "Activity subscribe",
        action: `${date} > ${start} - ${end}`,
        label: window.location.pathname
    });
export const trackActivitySelection = (type, label)=>DataLayer.push({
        category: "Activities filter",
        action: type,
        label: label
    });
export const trackCollectionSearch = (query)=>DataLayer.push({
        category: "Collection search",
        action: query,
        label: window.location.pathname
    });
export const trackCookiesAccepted = ()=>DataLayer.push({
        event: "cookies-accepted"
    });
export const trackCookiesDenied = ()=>DataLayer.push({
        event: "cookies-denied"
    });
export const pushBlogCategory = (categoryName)=>DataLayer.push({
        category: 'Blog overview',
        action: 'filter',
        label: categoryName
    });
export const pushSearchAction = (searchTerm)=>DataLayer.push({
        category: 'Search',
        action: 'Search',
        label: searchTerm
    });
(function(DataLayer) {
    DataLayer.getApi = ()=>window["dataLayer"] ? makeOpt(window["dataLayer"]) : emptyOpt();
    DataLayer.push = (data)=>{
        const Api = DataLayer.getApi();
        if (Api.kind == "some") {
            Api.value.push({
                event: "dnb-event",
                ...data
            });
        }
        if (Api.kind == "none" || !window['dataLayer']) {
            console.log("DataLayer or GTM not found, failed to push event", data);
        }
    };
})(DataLayer || (DataLayer = {}));
export var DataLayer;
